module.exports = __webpack_public_path__ + "img/yiyao_xiaofang_suoluetu.5dfa89f6.png";